import { render, staticRenderFns } from "./OnboardingError.vue?vue&type=template&id=c9dab91e&"
import script from "./OnboardingError.ts?vue&type=script&lang=ts&"
export * from "./OnboardingError.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports